const menuButtons = {
  display: {
    name: "menu.display",
    target: "display",
  },
  // compare: {
  //   name: "menu.compare",
  //   target: "compare",
  // },
  form: {
    name: "menu.form",
    target: "form",
    highlight: true,
  },
};

const homeButton = {
  name: "menu.home",
  target: "",
};

const availablePages = Object.keys(menuButtons);

export { menuButtons, homeButton, availablePages };
